import { Action } from './actions';

export interface IFeedback {
  opened: boolean;
}
export function feedbackReducer(state: IFeedback, action: Action): IFeedback {
  switch (action.type) {
    case 'FeedbackPopupOpened':
      return {
        ...state,
        opened: action.opened,
      };
    default:
      return state || { show: false, opened: false };
  }
}
